import React from 'react';
import PropTypes from 'prop-types';

import ProductPrice from 'components/Product/price';
import image from 'utils/image';

import { addCssPrefixTo } from 'utils';
import { MiniProduct, Image, TextWrapper, Name, Description, PriceContainer, Price } from './styles';

const propTypes = {
  onClick: PropTypes.func,
  showImage: PropTypes.bool,
  imagePath: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.number,
};

const defaultProps = {
  showImage: true,
};

const ProductOption = ({ onClick, showImage, imagePath, name, description, price }) => (
  <MiniProduct className={addCssPrefixTo('MINI_PRODUCT_OPTION')} onClick={onClick}>
    {showImage && imagePath && (
      <Image>
        <img src={image(imagePath, { width: 700 })} alt={name} />
      </Image>
    )}

    <TextWrapper>
      <Name>{name}</Name>
      <Description>{description}</Description>
    </TextWrapper>

    <PriceContainer>
      <Price>
        <ProductPrice price={price} />
      </Price>
    </PriceContainer>
  </MiniProduct>
);

ProductOption.propTypes = propTypes;
ProductOption.defaultProps = defaultProps;

export default ProductOption;
